import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../Context/UserContext';
import useAxiosCall from '../Hooks/useAxiosCall';
import { useNavigate } from 'react-router-dom';
import usePermissions from '../Hooks/usePermissions';
import { decryptData } from '../Utilities/CryptoUtility';
import useAutoLogout from '../Hooks/useAutoLogout';
import useTranslations from '../Hooks/useTranslations';
import useNotifications from '../Hooks/useNotifications';
import { SecureStorage } from '../Utilities/StorageEncryption';
const ProtectedRoute = ({ children }) => {
    useAutoLogout();
    const navigate = useNavigate();
    const { user, signIn, signOut } = useContext(UserContext);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const { makeApiCall } = useAxiosCall();
    const { fetchPermissions } = usePermissions();
    const { fetchTranslations } = useTranslations();
    const { fetchNotifications } = useNotifications();

    const handleApiCallSuccess = async ({ data }) => {
        let decryptedData = decryptData(data);
        signIn(decryptedData.user);
        setIsAuthenticated(true);
    };

    const handleApiCallError = (errorMessage) => {
        console.log(errorMessage);
        signOut();
        navigate('/login');
    };

    useEffect(() => {
        if ((user.accountType == "Support" && SecureStorage.getItem('domain') != null && SecureStorage.getItem('company') != null) || (user.accountType != "Support" && SecureStorage.getItem('domain') != null) ) {
            fetchPermissions();
            fetchTranslations();
            fetchNotifications();
        }
        checkAuthentication();
    }, []);

    const checkAuthentication = async () => {
        try {
            await makeApiCall({
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'GET',
                url: 'profile',
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    };

    return isAuthenticated ? children : null;
};

export default ProtectedRoute;
